export default {
  title: 'O seu próprio domínio',
  description:
    'Execute as aplicações da sua equipa num domínio seu em vez do endereço partilhado. Ligue o domínio uma vez: o painel, o portal de encomendas, o editor do site e o estúdio do site recebem cada um um endereço nele.',
  read_only_description:
    'O domínio em que este parceiro executa as suas aplicações. Só o parceiro pode ligá-lo ou desligá-lo.',
  read_only_empty: 'Este parceiro não ligou nenhum domínio.',
  not_connected: {
    label: 'Domínio',
    hint: 'O domínio que lhe pertence, sem www — por exemplo suamarca.pt. Depois, adicione no seu fornecedor de domínio os registos DNS que mostramos.',
    placeholder: 'suamarca.pt',
    connect: 'Ligar',
  },
  apps: {
    dashboard: 'Painel',
    oms: 'Portal de encomendas',
    storefront: 'Editor do site',
    website_studio: 'Estúdio do site',
  },
  status: {
    active: 'Ativo',
    pending: 'A aguardar DNS',
    failed: 'Requer atenção',
    disabled: 'Desligado',
  },
  records: {
    title: 'Adicione estes registos DNS para {{root}} no seu fornecedor de domínio',
  },
  instructions: {
    title: 'Como adicionar os registos',
    step_provider:
      'Inicie sessão onde o DNS de {{root}} é gerido — normalmente a empresa onde comprou o domínio, ou um serviço DNS como a Cloudflare.',
    step_add:
      'Abra as definições de DNS de {{root}} e adicione cada registo abaixo: escolha o tipo e copie o nome e o valor tal como estão. Deixe o TTL no valor predefinido.',
    step_check:
      'Guarde os registos e clique em «{{button}}». A maioria dos fornecedores publica as alterações em poucos minutos; alguns demoram até 48 horas.',
    tip_name:
      'No campo do nome, a maioria dos fornecedores quer apenas a parte antes de {{root}}, apresentada a negrito. Se o seu pedir o nome completo, copie o que aparece por baixo.',
    tip_cloudflare:
      'Na Cloudflare, defina os registos CNAME como «Apenas DNS» (nuvem cinzenta). Um registo com proxy esconde o CNAME, pelo que o domínio não pode ser verificado.',
    tip_existing: 'Mantenha os registos que já tem para {{root}} e www — o seu site continua a funcionar como antes.',
  },
  summary: {
    live: 'O seu painel está ativo em {{host}}.',
    pending:
      'Verificamos os seus registos DNS regularmente. Os novos registos podem demorar até 48 horas a ser encontrados.',
    failed:
      'Alguns registos não puderam ser verificados. Corrija os registos assinalados abaixo e verifique novamente.',
    relogin:
      'Assim que {{host}} estiver ativo, a sua equipa inicia sessão aí. Na primeira visita, terá de iniciar sessão novamente.',
  },
  buttons: {
    check_again: 'Verificar novamente',
    disconnect: 'Desligar',
    retry: 'Tentar novamente',
  },
  disconnect_confirm: {
    title: 'Desligar {{root}}?',
    description: 'As suas aplicações voltam ao endereço partilhado e as ligações em {{root}} deixam de funcionar.',
    ok: 'Desligar',
  },
  toasts: {
    load_error: 'Não foi possível carregar o seu domínio.',
    load_error_read_only: 'Não foi possível carregar o domínio deste parceiro.',
    connected: 'Domínio ligado. Adicione os registos DNS abaixo.',
    connect_failed: 'Não foi possível ligar o domínio.',
    check_started: 'A verificar os seus registos DNS.',
    check_failed: 'Não foi possível iniciar a verificação. Tente novamente dentro de um minuto.',
    disconnected: 'Domínio desligado.',
    disconnect_failed: 'Não foi possível desligar o domínio.',
  },
};
